import graphql__02a7761ed825f5d8cb01 from "./__generated__/MapUsersPoints_usersMap.graphql.js";import { graphql, useRefetchableFragment } from "react-relay";

import MarkerClusterGroup from "../MarkerClusterGroup";
import { createMapMarkerClusterIcon } from "../createMapMarkerClusterIcon";
import UsersMapUserMarker from "./UsersMapUserMarker";
import { useMapUsersFiltering } from "./useMapUsersFiltering";

export const USERS_MAP_USERS_MARKERS_COUNT = 2147483647;

const MapUsersPoints = props => {
  const [usersMap, refetch] = useRefetchableFragment(
    MapUsersPoints_usersMap,
    props.usersMap
  );

  // Ensure that the users list is refetched whenever a filter is updated
  useMapUsersFiltering(refetch);

  // Create the userMarker array by extracting the connection nodes from the edges
  // array and appending it the group's
  const userMarkers = usersMap.usersMapUsersMarkers.edges.map(({ node: userMarker }) => {
    const { style } = usersMap.usersMapUsersGroups.find(({ usersGroup }) =>
      userMarker.usersGroupIds.includes(usersGroup.id)
    );

    return { ...userMarker, style };
  });
  // Create a unique key with all the user ids to ensure that the
  // MarkerClusterGroup component is re-rendered when the users list is updated,
  // e.g. when filtering the users.
  const groupKey = userMarkers.map(({ id }) => id).join(":");

  return (
    <MarkerClusterGroup
      key={groupKey}
      showCoverageOnHover={false}
      maxClusterRadius={usersMap.markersMaxClusterRadius}
      iconCreateFunction={createMapMarkerClusterIcon}
    >
      {userMarkers.map(userMarker => (
        <UsersMapUserMarker key={userMarker.id} userMarker={userMarker} />
      ))}
    </MarkerClusterGroup>
  );
};

const MapUsersPoints_usersMap = graphql__02a7761ed825f5d8cb01;

export default MapUsersPoints;
